<template>
  <div>
    <HeaderComponent/>
    <template>
      <section class="reset">
        <div class="container">
          <div class="section-title">
            <h2>Reset Your Password</h2>
          </div>
        </div>
        <div class="password">
          <div class="col-lg-6 col-md-6 col-sm-12 password-from">
            <form @submit.prevent="reset" name="form1" class="login-form">
              <div class="form-group">
                <label for="password">New Password</label>
                <p class="control has-icon has-icon-right">
                  <input name="password" id="password" v-model="password" v-validate.persist="'required'" :class="{'input': true, 'is-danger': errors.has('password') }" class="form-control" type="password" placeholder="Password">
                  <i v-show="errors.has('password')" class="fa fa-warning"></i>
                  <span v-show="errors.has('password')" class="help is-danger">{{ errors.first('password') }}</span>
                </p>
              </div>
              <div class="form-group">
                <button type="submit" class="btn btn-dark login-button">Reset Password</button>
              </div>
            </form>
          </div>
        </div>
      </section>
    </template>
    <FooterComponent/>
  </div>
</template>

<script>
import HeaderComponent from '@/components/HeaderPayment';
import FooterComponent from '@/components/Footer.vue';
import axios from "axios";
export default {
  name: "ResetPassword",
  data() {
    return {
      password: '',
    }
  },
  components: {
    HeaderComponent,
    FooterComponent,
  },
  computed: {
    getUser() {
      return this.$store.state.authUser
    }
  },
  methods: {
    reset(e) {
      e.preventDefault();
      this.$validator.validateAll().then((result) => {
        if (result) {
          let instance = this;
          axios.get(`${this.apiPath}reset-password?key=${this.$route.query.key}&password=${this.password}`).then(function (response){
            instance.$toaster.success(response.data.message);
            instance.password = '';
            instance.$router.push('/');
          }.bind()).catch(function (error){
            instance.$toaster.error(error.response.data.message);
          });
        }
      });
    }
  }
}
</script>

<style scoped>
.reset {
  margin-top: 50px;
}
.password-from {
  margin: 0 auto;
}
.is-danger {
  color: #ee3434;
}
</style>